module.exports = __webpack_public_path__ + "static/media/warningicon.acc63b9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/warningicon.svg
// module id = 172
// module chunks = 0